var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activeCenter" },
    _vm._l(_vm.bannerAct, function(item, index) {
      return _c(
        "div",
        { key: index, staticClass: "activeItem" },
        [
          _c("p", { staticClass: "item_titles" }, [_vm._v(_vm._s(item.name))]),
          _vm._v(" "),
          _c("img", {
            staticClass: "itemBanner",
            attrs: { src: item.material.banner }
          }),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "footer_flex",
              attrs: {
                to: {
                  path: "Actives",
                  query: {
                    type: "banner",
                    url: item.material && item.material.banner,
                    id: item.id,
                    shopIDs: item.shops,
                    sharePicUrl: item.sharePicUrl && item.sharePicUrl,
                    shareTitle: item.shareTitle && item.shareTitle,
                    shareText: item.shareText && item.shareText,
                    code: _vm.code,
                    appcode: _vm.appcode,
                    shareAble: item.shareAble,
                    distributeType: item.distributeType
                  }
                }
              }
            },
            [
              _c("div", { staticClass: "footer_main" }, [
                _vm._v("\n        " + _vm._s(item.description) + "\n      ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "footer_btn" }, [_vm._v("详情 >")])
            ]
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c2c2552", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c2c2552","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/activeCenter/index.vue
// module id = null
// module chunks = 